import { render, staticRenderFns } from "./CreditsPurchasedVsUsed.vue?vue&type=template&id=877cae5a"
import script from "./CreditsPurchasedVsUsed.vue?vue&type=script&lang=js"
export * from "./CreditsPurchasedVsUsed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports